import { render, staticRenderFns } from "./app-4-page-not-found.vue?vue&type=template&id=4480e6d1&scoped=true&"
import script from "./app-4-page-not-found.vue?vue&type=script&lang=ts&"
export * from "./app-4-page-not-found.vue?vue&type=script&lang=ts&"
import style0 from "./app-4-page-not-found.vue?vue&type=style&index=0&id=4480e6d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480e6d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
